// The desk heartbeat, client side — pure parts, so they run under `npm test`.
//
// The heartbeat lives in SipProvider, NOT on the desk page (21 Oct 2026). The
// phone is registered at the app root and survives navigation — an agent takes
// calls from Conversations through the CallBar — but the heartbeat used to run
// only while the Agent desktop page was open. An Available agent who went to
// another page kept a working phone, stopped checking in, and three minutes
// later the server signed them out (server/ops/desk-heartbeat.ts): they stopped
// receiving queue calls with nothing on screen to say so. The heartbeat now
// runs wherever the phone is on.

/** How often a registered tab checks in. The server signs a desk out after
 *  three minutes of silence, so this leaves room for background throttling. */
export const HEARTBEAT_MS = 20_000;

/** Where the desk keeps the agent's own choice across reloads (VoiceSoftphone.tsx). */
export const CHOSEN_KEY = "chloe-ops:softphone-chosen";
export const PAUSE_REASON_KEY = "chloe-ops:softphone-pause-reason";

export interface ReassertBody {
  presence: "ready" | "paused";
  pauseReason?: string;
  /** This desk sends the heartbeat — see server/ops/desk-heartbeat.ts. */
  desk: true;
}

/**
 * What to re-announce after the server signed this desk out by mistake (it
 * stopped hearing the heartbeat, but the desk is plainly alive). The agent's own
 * choice, as the desk saved it: Paused with its reason, or Ready. Never a state
 * the agent did not pick — anything unrecognised is Ready, the desk's default.
 */
export function reassertBody(chosen: string | null, reason: string | null): ReassertBody {
  if (chosen === "paused") {
    const r = (reason ?? "").trim();
    return r ? { presence: "paused", pauseReason: r, desk: true } : { presence: "paused", desk: true };
  }
  return { presence: "ready", desk: true };
}
